import { Component } from '@angular/core';
import { Persona } from '../persona';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { HttpService } from '../services/http.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pimary-component',
  templateUrl: './pimary-component.component.html',
  styleUrls: ['./pimary-component.component.css']
})
export class PimaryComponentComponent {

  constructor(private toastr: ToastrService, private modalService: NgbModal, private dataService: HttpService, private router: Router) { }


  personas: Array<Persona> = [];
  cargando: boolean = false;
  cargando1: boolean = false;
  /*DASHBOARD*/
  asistenciaMesa: number = 0;
  totalEsperados: number = 0;
  totalAsistencias: number = 0;
  pendientes: number = 0;
  porcentaje: number = 0;
  presenciales: number = 0;
  representados: number = 0;
  /*********** */

  busquedaPersonas: Array<Persona> = [];
  filtroModal: string = '';
  mostrarReporte: boolean = false;

  // Filtra la lista del modal por nombre, identidad, colegiación o estado (sin distinguir mayúsculas ni tildes)
  get personasFiltradas(): Array<Persona> {
    let filtro = this.normalizar(this.filtroModal);
    if (filtro == '') {
      return this.busquedaPersonas;
    }
    return this.busquedaPersonas.filter(p =>
      [p.nombre, p.identidad, p.numeroColegiacion, p.status].some(campo => this.normalizar(campo).includes(filtro))
    );
  }

  private normalizar(valor: any): string {
    return (valor ?? '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }
  name: string;
  valor: number;

  dataReport: any;

  fnVerReporte() {

    if (this.mostrarReporte) {
      this.mostrarReporte = false;
      return;
    }
    this.cargando = true;
    this.dataService.getReport().subscribe(async result => {
      if (result['hasError']) {
        this.toastr.warning(result['errors'][0]['descripcion']);
      } else {
        this.dataReport = result['result']['data']['table0'];

        this.mostrarReporte = true;
      }
      this.cargando = false;

    });
  }
  showSuccess(msj) {
    this.toastr.success(msj, '');
  }

  async Agregar(content) {
    if (this.name == undefined || this.name == '') {
      this.toastr.error('Debe ingresar el nombre de la persona');
      return;
    }
    if (this.personas.length < 3) {
      this.buscar(content);
      this.name = '';

    } else {
      this.showSuccess('Llego al limite de personas');
    }
  }

  Acum() {
    let acum: number = 0;
    this.personas.forEach(function (value) {
      acum += value.monto;
    });
    this.valor = acum;
  }
  closeResult: string;
  async NuevaBusqueda(content) {
    if (this.name == undefined || this.name == '') {
      this.toastr.error('Debe ingresar el nombre de la persona');
      return;
    }
    this.removeLista();
    this.removePersons();

    await this.buscar(content);

  }

  private buscar(content) {
    if (!!this.modalService.hasOpenModals()) {
      console.log(1);
    } else {
      console.log(0);
    }
    this.cargando = true;
    this.dataService.getPerson(this.name, this.pageSize, 1, this.currentPage === 0 ? 1 : this.currentPage).subscribe(async result => {
      this.cargando = false;


      if (result['result']['hasError']) {
        this.toastr.info('Se ha producido un error, intentalo de nuevo')
        return;
      }

      let data: Array<any> = result["result"]["data"]["table0"];
      console.log('[img] datos del afiliado', data);

      if (data.length == 0) {
        this.toastr.warning('No se encontraron coincidencias');
        //this.name = '';
        return;
      }
      else if (data.length > 1) {
        await data.forEach(element => {
          this.busquedaPersonas.push(new Persona(element['idPersona'], element['nombreCompleto'], element['identidad'], element['numeroColegiacion'] ?? 'N/D', element['departamento'], element['municipio'], element['status'], element['grado'], element['monto'], element['voto'], element['mesa'], element['activoVotar'], false,element['idVotacion'], this.getKeyImg(element)));
        });
        //this.name = '';

        if (this.currentPage == 0) {

          this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });
        }


      }
      else if (data.length == 1) {

        /* if (result['result']['data']['Table0'][0]['activoVotar'] == 0) {
         this.toastr.warning('Esta persona no esta activo para realizar el voto');
         return;
       }  */
        let p = new Persona(data[0]['idPersona'], data[0]['nombreCompleto'], data[0]['identidad'], data[0]['numeroColegiacion'] ?? 'N/D', data[0]['departamento'], data[0]['municipio'], data[0]['status'], data[0]['grado'], data[0]['monto'], data[0]['voto'], data[0]['mesa'], data[0]['activoVotar'], this.personas.length == 0 ? true : false,data[0]['idVotacion'], this.getKeyImg(data[0]));

        this.fnAgregar(p);
        this.name = '';
      }
    },
      error => {
        this.dataService.handleError(error);
      });

  }

  // La imagen del afiliado viene en el campo url (enlace completo o clave del repositorio)
  private getKeyImg(element: any): string {
    let campo = Object.keys(element || {}).find(k => /^(url|key_?img)$/i.test(k));
    return campo ? element[campo] : null;
  }

  private getDismissReason(reason: any) {
    this.name = '';
    this.currentPage = 0;


  }
  async fnAgregar(personaNueva: Persona) {



    
    if (this.userData['idRol']==1 && this.personas.length>0)
    {
      this.toastr.info('Solo puede agregar una persona');
      return;
    }
    if (!personaNueva.estado) {
      this.toastr.warning('Esta persona no esta activa');
    }
    let existe: boolean = false;
    let res = await this.personas.forEach(function (v) {
      if (personaNueva.idPersona == v.idPersona) {
        existe = true;
      }
    });

    if (existe) {
      this.toastr.warning('Esta persona ya esta agregada');
      return;
    }
    if (this.personas.length < 3) {
      if (this.personas.length == 0) {
        personaNueva.seleccionado = true;
      }
      this.personas.push(personaNueva);
      this.Acum();

    } else {
      this.toastr.warning('Llego al limite de personas');
    }
  }


  fnCerrarSesion() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  userData: any;
  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('Usuario'));

    if (this.userData == null) {
      this.router.navigate(['/login']);
      return;
    }
    else {
      this.dataService.GetAllTickets(this.userData['idUser']).subscribe(async result => {
        if (result['hasError']) {
          this.toastr.warning(result['errors'][0]['descripcion']);
        } else {
          this.asignarValores(result['result'], 2);
        }
      });

    }

  }

  removePersons() {
    this.personas.splice(0, this.personas.length);
  }
  removeLista() {
    this.busquedaPersonas.splice(0, this.busquedaPersonas.length);
    this.filtroModal = '';
    this.page = 1;
  }
  async guardar() {
    if (this.personas.length > 1) {
      let control: boolean = false;
      let isEnable: boolean = false;
      let voto: boolean = false;
      this.personas.forEach(function (f) {
        if (f.seleccionado) {
          control = true;
        }
        if (!f.estado) {
          isEnable = true;
        }
        if (f.voto){
          voto=true;
        }
      });
      if (voto) {
        this.toastr.error("Hay personas que ya realizaron el voto");
        return;
      }
      if (isEnable) {
        this.toastr.error("Hay personas que no estan habilitadas para realizar el voto");
        return;
      }
      if (!control) {
        this.toastr.error("Debe seleccionar la cuenta principal");
        return;
      }

      let params = {
        "idUsuario": this.userData['idUser'],
        "idRepresentadoPor": 0,
        "personas": "",
        "monto": 20.00
      }
      let acum: string = "";
      await this.personas.forEach(function (v) {
        if (v.seleccionado) {
          params.idRepresentadoPor = v.idPersona

        }
        acum += v.idPersona + ','
      });
      params.personas = acum;


      this.cargando = true;

      this.dataService.putPerson(params).subscribe(async result => {
        if (result['hasError']) {
          this.toastr.warning(result['errors'][0]['descripcion']);
        } else {
          let data = result['data']['table0'][0];
          console.log(data)
          this.toastr.success(data['descripcion']);
          this.asignarValores(result, 0);
          this.removePersons();
          this.removeLista();
          this.imprimirTicket(data['idVotacion']);
        }
        this.cargando = false
      });
    } else {
      if (this.personas[0].voto) {
        this.toastr.info("Esta persona ya realizo el voto");
        return;
      }
      if (!this.personas[0].estado) {
        this.toastr.error("Hay personas que no estan habilitadas para realizar el voto");
        return;
      }

      let params = {
        "idUsuario": this.userData['idUser'],
        "idRepresentadoPor": this.personas[0].idPersona,
        "personas": this.personas[0].idPersona + ',',
        "monto": 20.00
      }
      this.cargando = true;
      this.dataService.putPerson(params).subscribe(async result => {
        if (result['hasError']) {
          this.toastr.warning(result['errors'][0]['descripcion']);
        } else {
          let data = result['data']['table0'][0];
          this.toastr.success(data['descripcion']);

          this.asignarValores(result, 0);

          this.removePersons();
          this.removeLista();
          this.imprimirTicket(data['idVotacion']);

        }
        this.cargando = false
      });
    }
  }

  asignarValores(result, origen) {
    console.log('Result',result)
    if (origen == 0) {
      this.asistenciaMesa = result['data']['table1'][0]['asistenciaMesa'];
      this.totalAsistencias = result['data']['table1'][0]['totalAsistencias'];
      this.pendientes = result['data']['table1'][0]['pendientes'];
      this.totalEsperados = result['data']['table1'][0]['totalEsperados'];
      this.presenciales = result['data']['table1'][0]['presenciales'];
      this.representados = result['data']['table1'][0]['representados'];
      this.porcentaje = ((this.totalAsistencias / this.totalEsperados ?? 1) * 100) ?? 0;
    } else {
      this.asistenciaMesa = result['data']['table0'][0]['asistenciaMesa'];
      this.totalAsistencias = result['data']['table0'][0]['totalAsistencias'];
      this.pendientes = result['data']['table0'][0]['pendientes'];
      this.totalEsperados = result['data']['table0'][0]['totalEsperados'];
        this.presenciales = result['data']['table1'][0]['presenciales'];
      this.representados = result['data']['table1'][0]['representados'];
      this.porcentaje = ((this.totalAsistencias / this.totalEsperados ?? 1) * 100) ?? 0;
    }

  }
  async fnHabilitar() {
    let isEnabled = false;
    await this.personas.forEach(function (v) {

      if (v.monto == 0) {
        isEnabled = true;
      }
    });
    if (isEnabled) {
      this.toastr.info('La persona ya esta activa');
      return;
    }
    else {
      let params = {
        "idUsuario": 1,
        "idPersona": this.personas[0].idPersona,
        "pin": 7896
      }
      this.cargando = true;
      this.dataService.setEnablePerson(params).subscribe(async result => {
        if (result['hasError']) {
          this.toastr.warning(result['errors'][0]['descripcion']);
        } else {
          let data = result['data']['table0'][0];
          this.toastr.success(data['descripcion']);
          this.removePersons();
          this.removeLista();
        }
        this.cargando = false
      });
    }
  }
  /*PAGINACION*/
  page = 1;
  pageSize = 5;
  pages = 5;// this.busquedaPersonas.length ?? 0;
  currentPage = 0;
  async pageChange(event, content) {


    /*   this.currentPage = event;
      //this.removeLista();
      await this.buscar(content); */
  }

  imprimirTicket(id: string) {
    const queryParams = {
      id: id,
    };
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/print-ticket'], {
        queryParams: queryParams,
      })
    );

    window.open(url, '_self');

  }

}
